export default __webpack_public_path__ + "static/media/devcarrot.ac3c526a.png";